import { merge } from 'lodash';

import initAnswers from './_answers';
import initConstants from './_constants';
import initQuestions from './_questions';
import initReports from './_reports';
import initSubmissions from './_submissions';

export default function (app) {
  const subModules = [
    initAnswers(app),
    initConstants(app),
    initQuestions(app),
    initReports(app),
    initSubmissions(app),
  ];

  const getDefaultState = () => ({
    loading: false,
    licenseKey: null,
    error: {},

    ...merge(...subModules.map(({ state, }) => state)),
  });

  const state = getDefaultState();

  const getters = {
    ...merge(...subModules.map(({ getters, }) => getters)),
  };

  const actions = {
    ...merge(...subModules.map(({ actions, }) => actions)),
  };

  const mutations = {
    resetState: state => Object.assign(state, getDefaultState()),
    setLicenseKey: (state, licenseKey) => state.licenseKey = licenseKey,
    setLoading: (state, loading) => state.loading = loading,
    setError: (state, error) => state.error = error,
    ...merge(...subModules.map(({ mutations, }) => mutations)),
  };

  return {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
  };
}
